import { RepeatScheduleWeekly } from "--root/static_types/shared.types";
import * as React from "react";
import styled from "styled-components";
import { Strings } from '--root/strings/en';

const STRINGS = Strings.dateTime;

const Wrapper = styled.div`
    display: flex;
    >*:not(:last-child) {
        margin-right: ${props => props.theme.spacing(0.5)};
    }
`;
type DayProps = {
    active?: boolean
}
const Day = styled.div<DayProps>`
    ${props => props.theme.typography.body2};
    margin: 0;

    display: flex;
    align-items: center;
    justify-content: center;
    width: ${props => props.theme.spacing(4)};
    height: ${props => props.theme.spacing(4)};
    background-color: ${props => props.active ? props.theme.palette.primary.main : props.theme.palette.background};
    color: ${props => props.active ? props.theme.palette.primary.contrast : props.theme.palette.text.secondary};
    border-radius: 100%;
    cursor: pointer;
`;

type DayPickerProps = {
    onChange?: (days: RepeatScheduleWeekly["weekDay"]) => void
}
const DayPicker: React.FC<DayPickerProps> = (props) => {
    const { onChange } = props;
    const days = STRINGS.daysShort;
    const [ selected, setSelected ] = React.useState<RepeatScheduleWeekly["weekDay"]>([false,false,false,false,false,false,false]);

    const onClick = (day: number) => {
        const tmpSelected:typeof selected = [...selected];
        tmpSelected[day] = !tmpSelected[day];
        setSelected(tmpSelected);
        onChange && onChange(tmpSelected);
    }

    return <Wrapper>
        {days.map((day, idx)=>
            <Day key={day} onClick={()=>onClick(idx)} active={selected[idx]}>{day}</Day>
        )}
    </Wrapper>
}

export default DayPicker;
export { DayPicker, DayPickerProps };